var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["mall", _vm.item.group] },
    [
      _c("div", { staticClass: "iconWrap" }, [
        _c("div", {
          staticClass: "icon",
          style: { backgroundImage: "url(" + _vm.displayIcon + ")" },
        }),
        _vm.item.group === "super_widget"
          ? _c(
              "div",
              {
                staticClass: "preview",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.onPreview(_vm.item)
                  },
                },
              },
              [
                _vm._v(" 预览 "),
                _c("img", {
                  staticClass: "btn-icon",
                  attrs: { src: require("@/assets/view_n.png") },
                }),
              ]
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "title" }, [
        _vm._v(" " + _vm._s(_vm.displayName) + " "),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewDialog,
            "append-to-body": "",
            "custom-class": "preview-dialog",
            title: "预览 - " + _vm.previewName,
            top: "10px",
            width: "420px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialog = $event
            },
          },
        },
        [
          _c("el-image", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewSrc, fit: "contain" },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addPanel } },
                [_vm._v("添加组件")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }